module.exports = __webpack_public_path__ + "static/media/house.8f9b470e.png";